import { render, staticRenderFns } from "./channelEditSkuDialog.vue?vue&type=template&id=a80de5f0&"
import script from "./channelEditSkuDialog.vue?vue&type=script&lang=ts&"
export * from "./channelEditSkuDialog.vue?vue&type=script&lang=ts&"
import style0 from "./channelEditSkuDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports